// South African ID numbers — mirrors backend/src/utils/saId.js so the form can
// check a number (and fill in date of birth and sex) as it is typed.
//   YYMMDD SSSS C A Z — date of birth, sex (<5000 female), citizenship, -, Luhn check digit

const pad = (n) => String(n).padStart(2, '0');

const luhnValid = (digits) => {
  let sum = 0;
  for (let i = 0; i < digits.length; i += 1) {
    let d = Number(digits[digits.length - 1 - i]);
    if (i % 2 === 1) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
};

export const parseSaId = (raw, today = new Date()) => {
  const id = String(raw || '').replace(/\s/g, '');
  if (!/^\d{13}$/.test(id)) return { valid: false, error: 'A South African ID number has 13 digits.' };
  const yy = Number(id.slice(0, 2));
  const mm = Number(id.slice(2, 4));
  const dd = Number(id.slice(4, 6));
  let year = 2000 + yy;
  if (new Date(Date.UTC(year, mm - 1, dd)) > today) year -= 100;
  const dob = new Date(Date.UTC(year, mm - 1, dd));
  if (mm < 1 || mm > 12 || dob.getUTCMonth() !== mm - 1 || dob.getUTCDate() !== dd) {
    return { valid: false, error: 'The first six digits are not a real date of birth (YYMMDD).' };
  }
  if (!['0', '1', '2'].includes(id[10])) return { valid: false, error: 'The 11th digit must be 0, 1 or 2.' };
  if (!luhnValid(id)) return { valid: false, error: 'That ID number fails its check digit — check it for a typo.' };
  return { valid: true, id, dateOfBirth: `${year}-${pad(mm)}-${pad(dd)}`, sex: Number(id.slice(6, 10)) < 5000 ? 'F' : 'M' };
};

export const initialsOf = (firstNames) =>
  String(firstNames || '').split(/[\s-]+/).filter(Boolean).map((w) => w[0].toUpperCase()).join('').slice(0, 10);

export const ageFrom = (dob, today = new Date()) => {
  if (!dob) return null;
  const [y, m, d] = dob.split('-').map(Number);
  let age = today.getFullYear() - y;
  if (today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d)) age -= 1;
  return age;
};

export const fmtDob = (dob) =>
  dob ? new Date(`${dob}T12:00:00`).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
